import React, { useMemo } from "react";
import DOMPurify from "dompurify";
import $ from "jquery";

const SANITIZE_CFG = { ALLOWED_TAGS: ["em", "b", "strong", "mark"] };
const BASE = "https://www.mizrahi-tefahot.co.il";
const DEFAULT_IMG = `${BASE}/images/Hacartis/default_image_search.jpg`;
const allowedHost = $('meta[name="siteDomain"]').attr("content");

function buildImageSrc(result) {
  let img = result?.image?.raw;
  if (Array.isArray(img)) img = img[0];
  if (!img) return DEFAULT_IMG;

  let s = String(img).trim();
  s = s.replace(/[;,\s]+$/g, ""); 
  if (/^(https?:)?\/\//i.test(s) || /^data:image\//i.test(s)) {
    return s;
  }

  return `${BASE}${s.startsWith("/") ? s : `/${s}`}`;
}

function isAllowedUrl(raw) {
  try {
    const u = new URL(String(raw || ""), window.location.origin);
    if (!/^https?:$/i.test(u.protocol)) return false;
    if (allowedHost && u.hostname !== allowedHost && u.hostname !== window.location.hostname) return false;
    return true;
  } catch {
    return false;
  }
}

export default function ResultView({ result }) {
  const urlAllowed = isAllowedUrl(result?.url?.raw);

  const href = useMemo(() => {
    if (!urlAllowed) return "#";
    return new URL(String(result.url.raw), window.location.origin).toString();
  }, [result, urlAllowed]);

  const imgSrc = buildImageSrc(result);

  if (!urlAllowed) {
    return null;
  }

  if (allowedHost && result?.url_host?.raw && result.url_host.raw !== allowedHost) {
    return null;
  }

  const titleHtml =
    result?.title?.snippet ??
    (result?.title?.raw ? DOMPurify.sanitize(result.title.raw, SANITIZE_CFG) : "ללא כותרת");

  const subtitleHtml =
    result?.meta_description?.snippet ??
    (result?.meta_description?.raw
      ? DOMPurify.sanitize(result.meta_description.raw, SANITIZE_CFG)
      : "");

  const bodyHtml =
    result?.body_content?.snippet ??
    (result?.body_content?.raw
      ? DOMPurify.sanitize(result.body_content.raw, SANITIZE_CFG)
      : "");

  return (
    <li className="sui-result">
      <a href={href} target="_blank" rel="noopener noreferrer" className="hacartisHotSale">
        <div className="sui-result__body">
          <ul className="sui-result__details">
            <li>
              <div className="sui-result__image" style={{ maxWidth: 140, paddingLeft: 24, paddingTop: 10 }}>
                <img
                  src={imgSrc}
                  alt=""
                  loading="lazy"
                  referrerPolicy="no-referrer"
                  style={{
                    display: "block",
                    width: 100,
                    height: 100,
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                  onError={(e) => { e.currentTarget.src = DEFAULT_IMG; }}
                />
              </div>

              <span
                className="sui-result__title sui-result__title-link"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(titleHtml, SANITIZE_CFG) }}
              />

              {subtitleHtml && (
                <>
                  <br />
                  <span
                    className="sui-result__subtitle"
                    style={{ fontSize: 14, color: "#666" }}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(subtitleHtml, SANITIZE_CFG) }}
                  />
                </>
              )}

              <br />

              <span
                className="sui-result__value"
                style={{ fontSize: 13 }}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bodyHtml, SANITIZE_CFG) }}
              />
            </li>
          </ul>
        </div>
      </a>
    </li>
  );
}
